import { render, staticRenderFns } from "./FactumAppealBookAppRightToAppealPg.vue?vue&type=template&id=de3f9b44&scoped=true"
import script from "./FactumAppealBookAppRightToAppealPg.vue?vue&type=script&lang=ts"
export * from "./FactumAppealBookAppRightToAppealPg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de3f9b44",
  null
  
)

export default component.exports